import React from 'react';
import LinkedInAdPreview from './LinkedInAdPreviewj';

const LinkedInAdsetForm = ({ dataItem = {}, onChange, type }) => {

    return (
        <div className='row mt-2'>
            <div className='col-8'>
                <div className='row'>
                    <div className='col-12'>
                        <label htmlFor='text'>Text *</label>
                        <textarea
                            name='text'
                            placeholder='Enter Text'
                            className="form-control form-control-sm"
                            value={dataItem.text}
                            onChange={onChange}
                        />
                    </div>
                    <div className='col-12 mt-2'>
                        <label htmlFor='landingPageUrl'>Landing Page URL *</label>
                        <input
                            name='landingPageUrl'
                            placeholder='Enter Landing Page URL'
                            className="form-control form-control-sm"
                            value={dataItem.landingPageUrl}
                            onChange={onChange}
                        />
                    </div>
                </div>
            </div>
            <div className='col-4'>
                <LinkedInAdPreview type={type} dataItem={dataItem} />
            </div>
        </div>
    )
}

export default LinkedInAdsetForm;
